import { App } from 'vue'
import { vPreventDefault } from '../directives/preventDefaultDirective'

export const preventDefaultPlugin = {
  install(app: App) {
    app.directive('prevent-default', vPreventDefault)
  },
}
